import React from "react";
import { About, OptForm } from "../components";
import { HeaderContainer } from "../containers/header";
import { FeaturesContainer } from "../containers/features";
import { ClientsContainer } from "../containers/clients";
import { CheckInContainer } from "../containers/checkIn";
import { SliderContainer } from "../containers/slider";
// import { TestimonialsContainer } from "../containers/testimonials";
import { BusinessContainer } from "../containers/business";
import axios from "axios";
import { FooterContainer } from "../containers/footer";
import { UsedByContainer } from "../containers/usedBy";

export default function Dashboard(props) {
  const [email, setEmail] = React.useState("");

  const sendMail = () => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      axios
        .get("https://vmsweb.ezyims.com/demo/", {
          params: {
            email: email,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setEmail("");
            alert("Email send to you successfully");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      alert("Invalid Email Address");
    }
  };
  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  return (
    <div>
      <HeaderContainer>
        <About>
          <About.Pane>
            <About.InfoContainer>
              <About.SubHeading>
                Qatar's First Digital Visitor Management System
              </About.SubHeading>
              <About.Heading>
              An integral part of a modern facility
              </About.Heading>
              <About.Text>
                VMS Smart App keep track of all the check-ins and check-outs of
                in the building and provide ease of access for the frequent
                visitors
              </About.Text>
              <OptForm>
                <OptForm.Input
                  placeholder="Enter your email"
                  onChange={handleChange}
                  value={email}
                />
                <OptForm.Button onClick={sendMail}>
                  Try Free Demo
                </OptForm.Button>
              </OptForm>
            </About.InfoContainer>
          </About.Pane>
          <About.Image src="/images/vmsphotos/images.png" />
        </About>
      </HeaderContainer>
      <FeaturesContainer />
      <ClientsContainer />
      <CheckInContainer />
      <SliderContainer />
      <UsedByContainer />
      {/* <TestimonialsContainer /> */}
      <BusinessContainer />
      <FooterContainer />
    </div>
  );
}
